<template>
  <template v-if="moduleEnCours">
    <div class="element__detail">
      <div class="flex flex-gap-1">
        <BasicText
          size="h4"
          weight="bold"
        >
          #{{ activeModuleIndex! + 1 }} Organisme de formation {{ moduleEnCours.typeModule }}
        </BasicText>
        <BasicIcon
          @click="définirModuleEnCours(null)"
          class="element__detail--hide"
          name="close"
        />
      </div>
      <BasicButton
        v-if="!readonly"
        variant="outlined"
        label="Supprimer"
        icon-name="minus-square"
        @click="supprimerModule(activeModuleIndex!)"
        class="element__detail--delete"
      />
    </div>
    <RechercheOrganisme :id="idScrollDownToSaisie" />
    <InformationsModule />
    <CoutFormation />
  </template>
</template>

<script setup lang="ts">
  import { inject } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDemandeCPROStore } from '@/features/interface/demande/cpro/useDemandeCPROStore'
  import { ModuleActionKey, type ModuleAction } from '../../useModuleActions'
  import RechercheOrganisme from '../recherche/RechercheOrganismeSection.vue'
  import InformationsModule from '../informations/InformationsModule.vue'
  import CoutFormation from '../frais/CoutFormation.vue'

  const store = useDemandeCPROStore()
  const { readonly } = storeToRefs(store)
  const { activeModuleIndex, supprimerModule, définirModuleEnCours, moduleEnCours, idScrollDownToSaisie } =
    inject<ModuleAction>(ModuleActionKey)!
</script>
